(function() {
  'use strict';

  class FilterPriceUpdater {
    constructor() {
      this.init();
    }

    init() {
      this.updatePricesFromURL();
      this.observeGridChanges();
      this.listenToURLChanges();
    }

    listenToURLChanges() {
      let lastUrl = location.href;
      new MutationObserver(() => {
        const url = location.href;
        if (url !== lastUrl) {
          lastUrl = url;
          setTimeout(() => this.updatePricesFromURL(), 500);
        }
      }).observe(document.querySelector('body'), { subtree: true, childList: true });
    }

    observeGridChanges() {
      const productGrid = document.querySelector('#product-grid');
      if (!productGrid) return;

      const observer = new MutationObserver(() => {
        setTimeout(() => this.updatePricesFromURL(), 300);
      });

      observer.observe(productGrid, {
        childList: true,
        subtree: false
      });
    }

    updatePricesFromURL() {
      const url = window.location.href;
      const filters = this.extractFiltersFromURL(url);
      
      if (Object.keys(filters).length > 0) {
        this.updateAllProductPrices(filters);
      }
    }

    extractFiltersFromURL(url) {
      const filters = {};
      const filterPattern = /filter\.v\.option\.([^=]+)=([^&]+)/g;
      let match;
      
      while ((match = filterPattern.exec(url)) !== null) {
        const optionName = decodeURIComponent(match[1]).toLowerCase();
        const optionValue = decodeURIComponent(match[2].replace(/\+/g, ' '));
        filters[optionName] = optionValue;
      }
      
      return filters;
    }

    updateAllProductPrices(filters) {
      const productCards = document.querySelectorAll('.collection-product-card');
      if (productCards.length === 0) return;
      
      productCards.forEach((card) => {
        this.updateProductPrice(card, filters);
      });
    }

    updateProductPrice(card, filters) {
      const productLink = card.querySelector('a[href*="/products/"]');
      if (!productLink) return;

      const productUrl = productLink.getAttribute('href');
      const productHandle = productUrl.split('/products/')[1].split('?')[0];
      
      fetch('/products/' + productHandle + '.js')
        .then(response => response.json())
        .then(productData => {
          const matchingVariants = productData.variants.filter(variant => {
            let matches = true;
            
            for (let filterValue of Object.values(filters)) {
              const variantMatches = 
                variant.option1 === filterValue || 
                variant.option2 === filterValue || 
                variant.option3 === filterValue;
              
              if (!variantMatches) {
                matches = false;
                break;
              }
            }
            
            return matches && variant.available;
          });

          if (matchingVariants.length > 0) {
            const minPrice = Math.min(...matchingVariants.map(v => v.price));
            const minVariant = matchingVariants.find(v => v.price === minPrice);
            this.updatePriceDisplay(card, minPrice, minVariant.compare_at_price);
          }
        })
        .catch(err => {
          // Silencioso en producción - solo loguear errores críticos
          if (err.status === 404) return;
          console.error('Error updating price:', err);
        });
    }

    updatePriceDisplay(card, price, comparePrice) {
      const priceContainer = card.querySelector('.price');
      if (!priceContainer) return;

      const regularPriceElement = priceContainer.querySelector('.price__regular .price-item--regular');
      const salePriceElement = priceContainer.querySelector('.price__sale .price-item--sale');
      const comparePriceElement = priceContainer.querySelector('.price__compare .price-item--regular');

      const formattedPrice = this.formatMoney(price);
      
      if (comparePrice && comparePrice > price) {
        if (salePriceElement) {
          salePriceElement.textContent = 'A partir de ' + formattedPrice;
        }
        if (comparePriceElement) {
          comparePriceElement.textContent = this.formatMoney(comparePrice);
        }
        priceContainer.classList.add('price--on-sale');
      } else {
        if (regularPriceElement) {
          regularPriceElement.textContent = 'A partir de ' + formattedPrice;
        }
      }
    }

    formatMoney(cents) {
      const amount = cents / 100;
      
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
      
      return '$ ' + amount.toLocaleString('es-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      new FilterPriceUpdater();
    });
  } else {
    new FilterPriceUpdater();
  }
})();
